module.exports = __webpack_public_path__ + "img/serve-background-01.528d4074.png";